<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    :max-width="maxWidth"
    content-class="pdialog"
  >
    <p-shadow-bevel
      class="position-relative overflow-visible"
      boxShadow="100"
      borderRadius="400"
      style="margin-top: 5rem"
    >
      <p-box
        class="overflow-visible"
        border-radius="400"
        background="bg-surface"
        style="--pc-box-shadow: var(--p-shadow-200); display: block"
      >
        <p-box
          class="d-flex dialog-heading"
          :padding="{ xs: '400' }"
          background="bg-surface-tertiary"
        >
          <p-text variant="headingMd" as="h3"> {{ title }} </p-text>
          <v-spacer></v-spacer>
          <p-btn icon-only variant="tertiary" @click="$emit('input', false)">
            <template #icon>
              <p-icon tone="base">
                <PX />
              </p-icon>
            </template>
          </p-btn>
        </p-box>
        <v-divider></v-divider>
        <div
          :style="{
            'max-height': $vuetify.breakpoint.smAndDown ? '55vh' : '65vh',
            'overflow-y': noScroll ? 'visible' : 'auto',
          }"
        >
          <p-box class="" :padding="{ xs: noPadding ? '0' : '400' }">
            <slot></slot>
          </p-box>
        </div>
        <template v-if="!hideFooter">
          <v-divider></v-divider>
          <p-box class="" :padding="{ xs: '400' }">
            <div class="d-flex justify-end gap-2">
              <slot name="footer">
                <p-btn @click="$emit('continue')" variant="primary">
                  {{ $t('ReviewRequestsConfiguration.continue') }}
                </p-btn>
              </slot>
            </div>
          </p-box>
        </template>

        <!--      <div class="" :padding="{ xs: '400' }">-->
        <!--      -->
        <!--      </div>-->

        <!--      <p-box class="" :padding="{ xs: '400' }">-->
        <!--        <div class="d-flex justify-end">-->
        <!--          <slot name="footer">-->
        <!--            <p-btn variant="primary"> {{ $t('ReviewRequestsConfiguration.continue') }} </p-btn>-->
        <!--          </slot>-->
        <!--        </div>-->
        <!--      </p-box>-->
      </p-box>
    </p-shadow-bevel>
  </v-dialog>
</template>

<script>
import PText from '@/components/polaris/PText';
import PShadowBevel from '@/components/polaris/PShadowBevel';
import PBox from '@/components/polaris/PBox';
import { getPIconComponents } from '@/components/polaris/polarisUtils';
import PBtn from '@/components/polaris/PBtn';
import PIcon from '@/components/polaris/PIcon';

export default {
  name: 'PDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    noScroll: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [Number, String],
      default: 600,
    },
    title: {
      type: String,
      default: '',
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    PBox,
    PShadowBevel,
    PText,
    PBtn,
    PIcon,
    ...getPIconComponents(['X']),
  },
};
</script>

<style lang="scss">
.pdialog.v-dialog {
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  box-shadow: none;

  .dialog-heading {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }
}

.pdialog.v-dialog {
  overflow: visible;
}

.dialog-content {
  height: 80% !important;
  //min-height: 250px;
  //height: 70vh !important;
  //overflow: auto;
}
</style>
